/**
 * Admin Header Component
 * Part of TASK-334: Frontend Admin Panel
 *
 * Header bar for the admin panel with branding and user info.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import { useAccount } from '../../contexts/AccountContext';

interface AdminHeaderProps {
  title?: string;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ title = 'Admin Panel' }) => {
  const navigate = useNavigate();
  const { user } = useAccount();

  return (
    <header className="bg-[#002B45] text-white shadow-md">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Left: Back button and branding */}
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/dashboard')}
              className="flex items-center gap-2 px-3 py-1.5 text-sm text-white/80 hover:text-white hover:bg-white/10 rounded-md transition-colors"
              title="Back to Dashboard"
            >
              <ArrowLeft size={18} />
              <span className="hidden sm:inline">Exit Admin</span>
            </button>

            <div className="h-6 w-px bg-white/20" />

            <div className="flex items-center gap-2">
              <Shield size={24} className="text-[#F7B500]" />
              <div>
                <h1 className="text-lg font-semibold">
                  Kielis <span className="text-[#F7B500]">{title}</span>
                </h1>
              </div>
            </div>
          </div>

          {/* Right: User info */}
          <div className="flex items-center gap-3">
            <div className="text-right">
              <p className="text-sm font-medium">{user?.displayName || user?.email}</p>
              <p className="text-xs text-white/60 capitalize">{user?.role}</p>
            </div>
            <div className="w-9 h-9 rounded-full bg-[#F7B500] flex items-center justify-center text-[#002B45] font-semibold text-sm">
              {(user?.displayName || user?.email || 'U').charAt(0).toUpperCase()}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
